
namespace TabAurous.Purchase {


    @Serenity.Decorators.registerClass()
    export class QuotationGrid extends _Ext.GridBase<QuotationRow, any> {
        protected getColumnsKey() { return 'Purchase.Quotation'; }
        protected getDialogType() { return QuotationDialog; }
        protected getIdProperty() { return QuotationRow.idProperty; }
        protected getInsertPermission() { return QuotationRow.insertPermission; }
        protected getLocalTextPrefix() { return QuotationRow.localTextPrefix; }
        protected getService() { return QuotationService.baseUrl; }
        //private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row);
           // QuotationItemsEditor.baseitemcheck = item.BaseItemTypeId;
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(54);
            this.editItem(<QuotationRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 54,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}